/* eslint-disable */
// Code generated by graphql-codegen. DO NOT EDIT.
/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
	  }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	/** Date (isoformat) */
	Date: { input: string; output: string }
	/** Date with time (isoformat) */
	DateTime: { input: string; output: string }
	join__DirectiveArguments: { input: any; output: any }
	join__FieldSet: { input: any; output: any }
	link__Import: { input: any; output: any }
}

export type AbortClaimInput = {
	cancelId: Scalars["String"]["input"]
}

/**
 * ActivateCouponMaster mutation は、クーポンマスターを表示状態にする。
 * - すでに表示状態の場合は、何もせず200を返す
 *
 * [error]
 * - Unexpected Error: 存在しないクーポンマスター
 */
export type ActivateCouponMasterInput = {
	id: Scalars["String"]["input"]
}

/**
 * ビューティメリットの設定
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はnullが帰る
 * - salonboard_setting は、サロンボードの設定。設定は任意で、これが設定されている場合は、スマート支払いをキャンセル一覧から除外できる。
 */
export type BeautyMeritSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	salonboardSetting: Maybe<SalonboardSetting>
	settingFieldsWithOptionalStoreId: ScrapingTargetSiteSettingFieldsWithOptionalStoreId
}

/**
 * BulkUpdateCancelPaymentStatus mutation は、複数のキャンセルの支払いステータスを一括で更新する。
 *
 * [error]
 * - Unexpected Error: サブスク決済失敗のキャンセルに対して以下の更新を行った場合
 *   - INVOICE_NOT_SENT から NOT_SUBJECT への更新
 *   - NOT_SUBJECT から INVOICE_NOT_SENT への更新
 */
export type BulkUpdateCancelPaymentStatusInput = {
	cancelIds: Array<Scalars["Int"]["input"]>
	paymentStatus: BulkUpdateCancelPaymentStatusPaymentStatusInput
}

/** BulkUpdateCancelPaymentStatusPaymentStatusInput は、一括更新するキャンセルの支払いステータスを指定する。 */
export type BulkUpdateCancelPaymentStatusPaymentStatusInput =
	| "INVOICE_NOT_SENT"
	| "NOT_SUBJECT"
	| "SCHEDULED_TO_CLAIM"

/**
 * BundleClaim mutation は、複数のキャンセル料の請求を一括送信する。
 * 各 cancel_id に対して sendInvoice と同等の処理を実行し、
 * 1件が失敗しても他の処理は続行する。
 */
export type BundleClaimInput = {
	cancelIds: Array<Scalars["String"]["input"]>
}

/** bundleClaim mutation のレスポンス。失敗したキャンセルの顧客名一覧を返す。 */
export type BundleClaimResponse = {
	/** 請求に失敗したキャンセルの顧客名一覧。全件成功時は空リスト。 */
	failedCancelNames: Array<Scalars["String"]["output"]>
}

/**
 * Cancel は、キャンセル情報を表す。
 *
 * - id: キャンセルID
 * - idv2: キャンセルIDv2
 * - salon_id: サロンID
 * - reserve_id: 予約ID
 * - message_kind: メッセージ種類
 * - cancel_type: キャンセルタイプ
 * - payment_status: 支払いステータス
 * - rereservation_status: 再予約状態
 * - rereservation_status_v2: 再予約状態
 *     - frontend からは呼ばれず,調査用の値が入る
 * - visit_counts: 来店回数
 * - is_visit_count_invalid: 来店回数が無効かどうか
 * - reserve_route: 予約ルート
 * - origin_price: 元の料金
 * - invoice_price: 請求金額
 * - staff_name: スタッフ名
 * - name: 名前
 * - phone_number: 電話番号
 * - paid_time: 支払い時間
 * - rereserved_time: 再予約時間
 * - date_visit: 来店日
 * - date_cancel: キャンセル日
 * - is_coupon_enabled: クーポンが有効かどうか
 * - is_created_by_ui: UIから作成されたかどうか
 * - cancel_coupon_master_specified_by: クーポンマスターIDが指定された方
 * - coupon_master: クーポンマスター
 * - first_encouraging_reresevation_scheduled_time: 最初の再予約促進メッセージ送信予定時間
 * - rereservation: 再予約
 * - should_use_default_coupon_master: 明示的にクーポンマスタ指定・もしくは使わない指定がされていない場合にデフォルトクーポンマスタを適用するべきかどうか
 * - has_lapsed_after_cancel: キャンセル後に顧客が再予約せずに離脱したかどうか
 */
export type Cancel = {
	cancelCouponMasterSpecifiedBy: CancelCouponMasterIdSpecifiedBy
	cancelType: CancelType
	claimingConversionAppliedTime: Maybe<Scalars["DateTime"]["output"]>
	couponMaster: Maybe<CouponMaster>
	dateCancel: Maybe<Scalars["String"]["output"]>
	dateVisit: Scalars["Date"]["output"]
	firstEncouragingReresevationScheduledTime: Maybe<
		Scalars["DateTime"]["output"]
	>
	/** キャンセル後に顧客が再予約せずに離脱したかどうか。来店予定日を含めて6日目以降（例: 1日なら6日以降）かつ30日以内で、rereserved_time が NULL なら True。feature flag LAPSED_AFTER_CANCEL_3_DAYS_AFTER が有効なサロンでは、6日目以降ではなく4日目以降で True。 */
	hasLapsedAfterCancel: Scalars["Boolean"]["output"]
	id: Scalars["Int"]["output"]
	idv2: Scalars["String"]["output"]
	invoicePrice: Scalars["Int"]["output"]
	isCouponEnabled: Scalars["Boolean"]["output"]
	isCreatedByUi: Scalars["Boolean"]["output"]
	isRereservationMessageSendingFailed: Scalars["Boolean"]["output"]
	isVisitCountInvalid: Scalars["Boolean"]["output"]
	messageKind: CancelMessageKind
	name: Scalars["String"]["output"]
	originPrice: Scalars["Int"]["output"]
	paidTime: Maybe<Scalars["DateTime"]["output"]>
	paymentId: Maybe<Scalars["String"]["output"]>
	paymentStatus: CancelPaymentStatus
	phoneNumber: Scalars["String"]["output"]
	rereservation: Maybe<Rereservation>
	/** reminder に紐づく再予約 incentive のうち、incentive_type=discount のときに設定される割引額。gift などの他タイプ、または incentive 非対象の場合は null。 */
	rereservationDiscountPrice: Maybe<Scalars["Int"]["output"]>
	/** 上野クリニック (枠受付) で顧客が受け付けた第一希望日時。枠受付は実予約 (rereservation) を作らないため、受付済みの場合のみ設定される。 */
	rereservationRequestFirstStartTime: Maybe<Scalars["DateTime"]["output"]>
	rereservationStatus: CancelRereservationStatus
	rereservationStatusV2: CancelRereservationStatusV2
	rereservedTime: Maybe<Scalars["DateTime"]["output"]>
	reserveId: Scalars["String"]["output"]
	reserveRoute: Scalars["String"]["output"]
	salonId: Scalars["Int"]["output"]
	shouldUseDefaultCouponMaster: Scalars["Boolean"]["output"]
	staffName: Maybe<Scalars["String"]["output"]>
	visitCounts: Scalars["Int"]["output"]
}

/**
 * CancelCouponMasterIDSpecifiedBy は、クーポンマスターIDが指定された方を表す。
 *
 * - UNSPECIFIED: 指定なし
 * - USER: ユーザー指定
 * - DEFAULT: デフォルト
 */
export type CancelCouponMasterIdSpecifiedBy = "DEFAULT" | "UNSPECIFIED" | "USER"

/**
 * CancelMessageKind は、請求機能、再予約案内機能のどちらの対象のキャンセルかを表す
 *
 * - CLAIM_CANCEL_FEE: キャンセル料請求
 * - ENCOURAGE_RERESERVATION: 再予約案内
 * - CLAIMING_CONVERSION: 請求変換 (再予約案内 => キャンセル料請求 への転換が行われる kind.)
 * - ENCOURAGE_CONVERSION: 再予約転換 (キャンセル料請求(手動) => 再予約案内 への転換が行われる kind.)
 */
export type CancelMessageKind =
	| "CLAIMING_CONVERSION"
	| "CLAIM_CANCEL_FEE"
	| "ENCOURAGE_CONVERSION"
	| "ENCOURAGE_RERESERVATION"

/**
 * CancelPaymentStatus は、キャンセルの支払いステータスを表す。
 *
 * - INVOICE_NOT_SENT: 請求書未送付
 * - INVOICE_SENT: 請求書送付済
 * - PAID: 支払済
 * - NOT_SUBJECT: 請求対象外
 * - SCHEDULED_TO_CLAIM: 請求予定
 * - CLAIM_ABORTED: 請求停止
 */
export type CancelPaymentStatus =
	| "CLAIM_ABORTED"
	| "INVOICE_NOT_SENT"
	| "INVOICE_SENT"
	| "NOT_SUBJECT"
	| "PAID"
	| "SCHEDULED_TO_CLAIM"

/**
 * CancelRereservationStatus は、キャンセルの再予約状態を表す。
 * spec: https://miro.com/app/board/uXjVL32FNf8=/?moveToWidget=3458764610717760210&cot=14
 *
 * - ENCOURAGING_RERESERVATION_NOT_SCHEDULED: 再予約促進メッセージ未送付
 * - INFORMATION_NOT_ENOUGH: 送付情報不足
 * - CANNOT_ENCOURAGE: 送付対象外
 * - ENCOURAGING_RERESERVATION_SCHEDULED: 送付予定
 * - ENCOURAGING_MESSAGE_SENT: 送付済
 * - ENCOURAGING_MESSAGE_ABORTED: 送付停止
 * - ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED: 他媒体で予約。案内の送付後に RefundHub 以外（予約サイト等）で再予約されたのを予約データの取り込みで検知し、送付を止めたもの
 * - RERESERVED: 再予約済
 * - RERESERVATION_CANCELED: キャンセル済
 * - RERESERVATION_VISITED: 来店済
 * - RERESERVED_BY_REFUND_HUB: KOKUA経由で再予約済
 * - RERESERVED_BY_OTHER_THAN_REFUND_HUB: KOKUA以外で再予約済
 */
export type CancelRereservationStatus =
	| "CANNOT_ENCOURAGE"
	| "ENCOURAGING_MESSAGE_ABORTED"
	| "ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED"
	| "ENCOURAGING_MESSAGE_SENT"
	| "ENCOURAGING_RERESERVATION_NOT_SCHEDULED"
	| "ENCOURAGING_RERESERVATION_SCHEDULED"
	| "INFORMATION_NOT_ENOUGH"
	| "RERESERVATION_CANCELED"
	| "RERESERVATION_VISITED"
	| "RERESERVED"
	| "RERESERVED_BY_OTHER_THAN_REFUND_HUB"
	| "RERESERVED_BY_REFUND_HUB"

/**
 * CancelRereservationStatusV2 は、キャンセルの再予約状態を表す。
 * frontend からは呼ばれず,調査用の値が入る
 * spec: https://miro.com/app/board/uXjVL32FNf8=/?moveToWidget=3458764610717760210&cot=14
 *
 * - ENCOURAGING_RERESERVATION_NOT_SCHEDULED: 再予約促進メッセージ未送付
 * - INFORMATION_NOT_ENOUGH: 送付情報不足
 * - CANNOT_ENCOURAGE: 送付対象外
 * - ENCOURAGING_RERESERVATION_SCHEDULED: 送付予定
 * - ENCOURAGING_MESSAGE_SENT: 送付済
 * - ENCOURAGING_MESSAGE_ABORTEDBY_USER_OR_CUSTOMER: 店舗または顧客からの送付停止
 * - ENCOURAGING_MESSAGE_ABORTED_BY_RERSERVATION_SETTING_CHANGE: 店舗の設定変更による送付停止
 * - ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED:再予約されたことによる送付停止
 * - UNABLE_TO_ENCOURAGE_BECAUSE_OF_INSUFFICIENT_CANCEL_FIELDS: オペレーションミスにより送付してしまったものを送付停止
 * - RERESERVED: 再予約済
 * - RERESERVATION_CANCELED: キャンセル済
 * - RERESERVATION_VISITED: 来店済
 * - RERESERVED_BY_REFUND_HUB: KOKUA経由で再予約済
 * - RERESERVED_BY_OTHER_THAN_REFUND_HUB: KOKUA以外で再予約済
 */
export type CancelRereservationStatusV2 =
	| "CANNOT_ENCOURAGE"
	| "ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED"
	| "ENCOURAGING_MESSAGE_ABORTED_BY_RERSERVATION_SETTING_CHANGE"
	| "ENCOURAGING_MESSAGE_ABORTED_BY_USER_OR_CUSTOMER"
	| "ENCOURAGING_MESSAGE_SENT"
	| "ENCOURAGING_RERESERVATION_NOT_SCHEDULED"
	| "ENCOURAGING_RERESERVATION_SCHEDULED"
	| "INFORMATION_NOT_ENOUGH"
	| "RERESERVATION_CANCELED"
	| "RERESERVATION_VISITED"
	| "RERESERVED"
	| "RERESERVED_BY_OTHER_THAN_REFUND_HUB"
	| "RERESERVED_BY_REFUND_HUB"
	| "UNABLE_TO_ENCOURAGE_BECAUSE_OF_INSUFFICIENT_CANCEL_FIELDS"

/**
 * CancelType は、キャンセルのタイプを表す。
 *
 * 一般的なキャンセルタイプ:
 * - UNSPECIFIED: 不明
 * - NO_CONFIRMATION: 無断キャンセル
 * - PREVIOUS_DAY: 前日キャンセル
 * - ON_THE_DAY: 当日キャンセル
 * - MORE_THAN_TWO_DAYS_AGO: 2日以上前のキャンセル
 * - FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO: 前日から2日前のキャンセル
 * - MORE_THAN_THREE_DAYS_AGO: 3日以上前のキャンセル
 * - SUBSCRIPTION_PAYMENT_FAILED: サブスクリプション決済失敗
 * - CLAIMING_CONVERSION_RECANCEL: feature_flags の is_claiming_conversion_recancel_enabled が true の時に作成される,請求転換によって作成された再予約がキャンセルされた際のキャンセルタイプ
 *     - このキャンセルタイプには,無断かどうかやキャンセル日に関わらず請求を行う.
 *
 * SKクリニック専用のキャンセルタイプ:
 * - SK_CLINIC_*: 各診療科・カウンセリング別のキャンセルタイプ
 */
export type CancelType =
	| "CLAIMING_CONVERSION_RECANCEL"
	| "FIVE_DAYS_AGO"
	| "FOUR_DAYS_AGO"
	| "FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO"
	| "MANUAL_INVOICE_PRICE_SETTING"
	| "MORE_THAN_FOUR_DAYS_AGO"
	| "MORE_THAN_SIX_DAYS_AGO"
	| "MORE_THAN_THREE_DAYS_AGO"
	| "MORE_THAN_TWO_DAYS_AGO"
	| "NO_CONFIRMATION"
	| "ON_THE_DAY"
	| "PREVIOUS_DAY"
	| "SK_CLINIC_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DENTAL_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DENTAL_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DENTAL_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DENTAL_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DENTAL_ON_THE_DAY"
	| "SK_CLINIC_DENTAL_UNSPECIFIED"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DERMATOLOGY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_ON_THE_DAY"
	| "SK_CLINIC_DERMATOLOGY_UNSPECIFIED"
	| "SK_CLINIC_MANUAL_INVOICE_PRICE_SETTING"
	| "SK_CLINIC_SURGERY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGERY_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_SURGERY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_SURGERY_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGERY_ON_THE_DAY"
	| "SK_CLINIC_SURGERY_UNSPECIFIED"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_UNSPECIFIED"
	| "SK_CLINIC_UNKNOWN"
	| "SUBSCRIPTION_PAYMENT_FAILED"
	| "THREE_DAYS_AGO"
	| "TWO_DAYS_AGO"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FAMILY_CONSULTATION"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FEAR"
	| "UENO_CLINIC_CONFIRMED_CANCEL_PRICE"
	| "UENO_CLINIC_CONFIRMED_CANCEL_SCHEDULE"
	| "UENO_CLINIC_FAMILY_CONSULTATION"
	| "UENO_CLINIC_FEAR"
	| "UENO_CLINIC_OTHER"
	| "UENO_CLINIC_PRICE"
	| "UENO_CLINIC_SCHEDULE"
	| "UNSPECIFIED"

/** キャンセルタイプ,表示用テキスト,請求できるかどうかまとめたクラス */
export type CancelTypeInfo = {
	/** キャンセルタイプ */
	cancelType: CancelType
	/** 表示用のテキスト */
	text: Scalars["String"]["output"]
}

export type CancelsAttachedToCouponMaster = {
	/** 請求済、回収済のキャンセルのみ取得 */
	cancels: Array<Cancel>
	relationSummary: CouponMasterRelationSummary
}

export type ClaimRule = {
	id: Scalars["Int"]["output"]
	text: Scalars["String"]["output"]
}

/**
 * ClaimedCancelsResponse は、請求済キャンセルのレスポンスを表す。
 *
 * - cancels: 請求済キャンセルリスト
 */
export type ClaimedCancelsResponse = {
	cancels: Array<Cancel>
}

/** Company */
export type Company = {
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
}

export type CouponMaster = {
	cancelsAttachedToCouponMaster: CancelsAttachedToCouponMaster
	discountAmount: Maybe<Scalars["Int"]["output"]>
	discountPercent: Maybe<Scalars["Int"]["output"]>
	expireDurationDay: Scalars["Int"]["output"]
	id: Scalars["String"]["output"]
	minAmount: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
	targetName: Scalars["String"]["output"]
}

/**
 * CouponMasterInput は、クーポンマスターを作成するためのパラメータ。
 *
 * - name: クーポン名
 * - target_name: 適用対象名
 * - discount_amount: 割引金額 (discount_percentと排他)
 * - discount_percent: 割引率 (discount_amountと排他)
 * - expire_duration_day: 有効期限(日)
 * - min_amount: 最低適用金額
 * - is_default_coupon_master: デフォルトクーポンとして設定するかどうか
 *
 * [error]
 * - Unexpected Error: 以下のいずれかの場合
 *   - discount_amountとdiscount_percentの両方がNone
 *   - discount_amountとdiscount_percentの両方が指定されている
 * - BadRequestError: 割引額が上限値を超えている
 *     - 割引額が50,000円を超えている
 *     - 割引率が100%を超えている
 */
export type CouponMasterInput = {
	discountAmount?: InputMaybe<Scalars["Int"]["input"]>
	discountPercent?: InputMaybe<Scalars["Int"]["input"]>
	expireDurationDay: Scalars["Int"]["input"]
	isDefaultCouponMaster?: Scalars["Boolean"]["input"]
	minAmount: Scalars["Int"]["input"]
	name: Scalars["String"]["input"]
	targetName: Scalars["String"]["input"]
}

export type CouponMasterRelationSummary = {
	invoiceCount: Scalars["Int"]["output"]
	issuedCount: Scalars["Int"]["output"]
	usedCount: Scalars["Int"]["output"]
}

/**
 * couponMasters query は、クーポンマスターの一覧を取得する。
 * - id降順で返却
 * - is_activeで表示/非表示を選択可能
 */
export type CouponMastersParam = {
	isActive: Scalars["Boolean"]["input"]
}

export type CreateCancelCancelTypeInput =
	| "FIVE_DAYS_AGO"
	| "FOUR_DAYS_AGO"
	| "FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO"
	| "MANUAL_INVOICE_PRICE_SETTING"
	| "NO_CONFIRMATION"
	| "ON_THE_DAY"
	| "PREVIOUS_DAY"
	| "SK_CLINIC_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DENTAL_ON_THE_DAY"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_ON_THE_DAY"
	| "SK_CLINIC_MANUAL_INVOICE_PRICE_SETTING"
	| "SK_CLINIC_SURGERY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_SURGERY_ON_THE_DAY"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SUBSCRIPTION_PAYMENT_FAILED"
	| "THREE_DAYS_AGO"
	| "TWO_DAYS_AGO"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FAMILY_CONSULTATION"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FEAR"
	| "UENO_CLINIC_CONFIRMED_CANCEL_PRICE"
	| "UENO_CLINIC_CONFIRMED_CANCEL_SCHEDULE"
	| "UENO_CLINIC_FAMILY_CONSULTATION"
	| "UENO_CLINIC_FEAR"
	| "UENO_CLINIC_OTHER"
	| "UENO_CLINIC_PRICE"
	| "UENO_CLINIC_SCHEDULE"

/**
 * CreateCancel mutation は、新規キャンセルを作成する。
 * - reserve_idはulidを使用するため、冪等性は保証されない
 * - payment_statusをCLAIMEDで作成した場合、stripe intentも作成される
 *
 * [error]
 * - Unexpected Error: 指定されたcoupon_master_idが該当サロンに存在しない場合
 */
export type CreateCancelInput = {
	cancelType: CreateCancelCancelTypeInput
	couponMasterId?: InputMaybe<Scalars["String"]["input"]>
	name: Scalars["String"]["input"]
	originPrice: Scalars["Int"]["input"]
	paymentStatus: CreateCancelPaymentStatusInput
	phoneNumber: Scalars["String"]["input"]
	reservationDate: Scalars["Date"]["input"]
	staffName?: InputMaybe<Scalars["String"]["input"]>
	visitCounts: Scalars["Int"]["input"]
}

export type CreateCancelPayload = {
	cancel: Cancel
}

export type CreateCancelPaymentStatusInput = "CLAIMED" | "NOT_CLAIMED"

export type CreateCouponMasterPayload = {
	couponMaster: CouponMaster
	salon: Salon
}

/**
 * DeactivateCouponMaster mutation は、クーポンマスターを非表示状態にする。
 * - すでに非表示状態の場合は、何もせず200を返す
 * - INVOICE_NOT_SENT状態のキャンセルが紐付いている場合、その紐付きを削除
 * - デフォルトのクーポンである場合、デフォルトのクーポンでなくなる
 *
 * [error]
 * - Unexpected Error: 非表示状態のクーポンを指定した場合
 */
export type DeactivateCouponMasterInput = {
	id: Scalars["String"]["input"]
}

export type DeactivateCouponMasterPayload = {
	couponMaster: CouponMaster
	salon: Salon
}

/**
 * DeleteSalonUser mutation は、サロンユーザーを削除する。
 * - ユーザーのuser_salon_mappingと招待情報を削除
 *
 * [error]
 * - TODO: 具体的なエラー名
 * - PERMISSION_DENIED_ERROR: 権限不足
 * - Unexpected Error: 以下のいずれかの場合
 *   - 指定されたユーザーが現在ログインしているサロンに所属していない
 *   - オーナーユーザーを削除しようとした
 */
export type DeleteSalonUserInput = {
	userId: Scalars["String"]["input"]
}

export type DeleteSalonUserResponse = {
	ok: Scalars["Boolean"]["output"]
}

/**
 * EncourageRereservationMessageNotSentCancelsResponse は、再予約促進メッセージ未送付キャンセルのレスポンスを表す。
 *
 * - cancels: 再予約促進メッセージ未送付キャンセルリスト
 */
export type EncourageRereservationMessageNotSentCancelsResponse = {
	cancels: Array<Cancel>
}

/**
 * EncourageRereservationMessageSentCancelsResponse は、再予約促進メッセージ送付済キャンセルのレスポンスを表す。
 *
 * - cancels: 再予約促進メッセージ送付済キャンセルリスト
 */
export type EncourageRereservationMessageSentCancelsResponse = {
	cancels: Array<Cancel>
}

/** エパークとサロンボードの設定 */
export type EparkAndSalonboardSetting = {
	eparkSetting: EparkSetting
	salonboardSetting: SalonboardSetting
}

/** エパークの設定 */
export type EparkSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithBaseUrl: ScrapingTargetSiteSettingFieldsWithBaseUrl
}

export type FeatureFlag = {
	forceEmptyWhenCannotReserveCanceledReservationMenuSet: Scalars["Boolean"]["output"]
	isEncouragingRereservationEnabled: Scalars["Boolean"]["output"]
	salonId: Scalars["Int"]["output"]
}

/**
 * InviteSalonUser mutation は、新規ユーザーをサロンに招待する。
 * - 指定された email でユーザーがすでに店舗に所属する場合:
 *   - すでにログイン済みの場合は何もしない
 *   - 未ログインの場合は招待メールを送信します
 * - 所属していない場合:
 *   - ユーザーを作成し、サロンに対する権限を与え、招待メールを送信します
 *
 * [error]
 * - TODO:
 * - Exception: 以下のいずれかの場合
 *   - 無効なメールアドレス
 *   - MEMBERまたはADMIN以外のロールを指定
 *   - 指定された email でユーザー が店舗に所属しないかつ、role が owner である場合 (owner をこの API から作成することはできない。なお、email の再送信のみなら可能)
 */
export type InviteSalonUserInput = {
	email: Scalars["String"]["input"]
	role: Role
}

export type InviteSalonUserResponse = {
	ok: Scalars["Boolean"]["output"]
}

/**
 * InvoicePriceParam は、キャンセル料金を計算するためのパラメータ。
 *
 * - origin_price: 予約時の料金 (負の値の場合は0として扱う)
 * - cancel_type: キャンセルタイプ
 * - visit_counts: 来店回数。キャンセル手動作成画面では入力された値、未請求一覧の行編集ではそのキャンセルの来店回数を渡す。
 *   既存客の当日キャンセル 50% 請求（feature flag HALF_INVOICE_PRICE_ON_THE_DAY_CANCEL_FOR_EXISTING_CUSTOMER）の
 *   新規客 / 既存客の判定に使う (0 回なら新規客)。
 *   無い場合は、上記 50% 請求を適用しない通常額を返す
 */
export type InvoicePriceParam = {
	cancelType: CreateCancelCancelTypeInput
	originPrice: Scalars["Int"]["input"]
	visitCounts?: InputMaybe<Scalars["Int"]["input"]>
}

export type InvoicePriceResponse = {
	invoicePrice: Scalars["Int"]["output"]
}

/**
 * かんざしの設定
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はnullが帰る
 */
export type KanzashiSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithOptionalStoreId: ScrapingTargetSiteSettingFieldsWithOptionalStoreId
}

/** キレイパスコネクトの設定 */
export type KireipassConnectSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithOnlyId: ScrapingTargetSiteSettingFieldsWithOnlyId
}

/**
 * LoadCancels Mutation は現在ログインしている店舗の予約・キャンセルを取得します.
 *   - 新たに取得したキャンセルがサロン都合キャンセルや緊急事態キャンセルであった場合,cancel_reason_type を salon_cancel,emergency に設定し、自動請求や再予約案内の送付は行われません.
 *   - 新たに取得したキャンセルが電話による予約であった場合( is_phone_reservation = Trueの場合),電話予約を自動請求から除外する店舗であれば(FeatureFlag.is_phone_reservation_excluded_from_auto_claim = True であれば)請求転換による再予約を除き自動請求は行われません
 *   - 新たに取得したキャンセルの予約経路が minimo と判別された場合( reserve_route_type = MINIMO の場合),feature flag EXCLUDE_MINIMO_RESERVE_ROUTE_FROM_AUTO_CLAIM が有効な店舗では自動請求と請求転換による再予約案内は行われません(非請求には倒さないため手動請求は可能。予約経路を判別できない媒体は対象外)
 *   - 新たに取得したキャンセルの予約経路が楽天ビューティーと判別された場合( reserve_route_type = RAKUTEN_BEAUTY の場合),feature flag EXCLUDE_RAKUTEN_RESERVE_ROUTE_FROM_AUTO_CLAIM が有効な店舗では自動請求と請求転換による再予約案内は行われません(非請求には倒さないため手動請求は可能。予約経路を判別できない媒体は対象外)
 *   - feature flag EXCLUDE_NON_HPB_RESERVE_ROUTE_FROM_AUTO_CLAIM が有効な店舗では,新たに取得したキャンセルの予約経路が HPB( HOT PEPPER Beauty )と判別された場合( reserve_route_type = HOT_PEPPER_BEAUTY の場合)のみ自動請求と請求転換による再予約案内を行い,それ以外( minimo・楽天ビューティーのほか,予約経路を判別できなかった UNSPECIFIED・経路情報を返さない媒体の None も含む)では行いません(非請求には倒さないため手動請求は可能)
 *   - feature flag LORAINE_BROW_EXCLUDE_OTHER_RESERVE_ROUTE_FROM_AUTO_CLAIM( ロレインブロウ個社対応 )が有効な店舗では,新たに取得したキャンセルの予約経路が次回予約( reserve_route = 次回予約 )か HPB( reserve_route_type = HOT_PEPPER_BEAUTY または生テキストが HPB )の場合のみ自動請求と請求転換による再予約案内を行い,それ以外のその他経路( 通常予約・ネット予約・minimo・楽天ビューティーのほか,判別できなかった UNSPECIFIED・None も含む)では行いません(非請求には倒さないため手動請求は可能)
 *   - 新たに取得したキャンセルが請求転換による再予約のものであって cancel_reason_type が normal の場合,無断かどうかやキャンセル日に関わらず cance_type を CLAIMING_CONVERSION_RECANCEL にして前回の予約金額の 100% の金額で請求をします.
 *     - 0 円予約の場合は,前回のキャンセルタイプの 0 円予約の金額で請求します。 (前回のキャンセルのキャンセルタイプの 0 円予約の請求金額は,請求転換対象になる時点で必ず 0 ではない)
 *   - 新たに取得したキャンセルが Salonboard から取得した HotPepperBeauty 経由の予約であって前日以前のキャンセルの場合,既に DB にある salon_id と reserve_id が一致する reservation の previous_scraping_success_time を reservation_receipted_time として使用します。
 *     - DB に対象の reservation がない時には,前回のスクレイピング成功した日時を reservation_receipted_time とします。(初回成功時 は Null)
 *   - is_encouraging_forbidden_due_to_nabeko_staff_mapping_lack = True の場合、再予約案内の送付は行われません。
 */
export type LoadCancelsInput = {
	mode?: LoadCancelsModeInput
}

/**
 * LoadCancelsModeInput は、キャンセルデータの取得モードを指定する。
 *
 * - NORMAL: 通常モード (dbにないキャンセルのみ取得し、dbに追加)
 * - DRYRUN: dryrunモード (dbにないキャンセルのみ取得し、dbに追加しない)
 * - TIME_MEASUREMENT: time measurementモード (dbにないキャンセルも取得し、dbには追加しない)
 */
export type LoadCancelsModeInput = "DRYRUN" | "NORMAL" | "TIME_MEASUREMENT"

export type LoadCancelsPayload = {
	ok: Scalars["Boolean"]["output"]
}

/**
 * MakeSelfSalonOwner mutation は、呼び出した souhl_admin ユーザー自身を、現在ログイン中のサロンの owner にする。
 * - souhl_admin 専用 (token 検証で souhl_admin でなければ弾く。@minRole では role=OWNER の本物 owner も
 *   通ってしまうため directive ではなく resolver 側で is_souhl_admin を検証する)
 * - 自身以外の既存 owner は全て admin に降格し、owner を自分 1 人だけにする
 *   (owner が複数いる不整合データでも、手で削除クエリを流さずに 1 人に収束させられる)
 * - owner が 1 人もいないサロンでも自身を owner にする
 * - 既に自身が唯一の owner の場合は何もしない
 * - 想定運用: souhl_admin が一度自分を owner にしてから switchSalonOwner で本来の owner に引き継ぐ
 */
export type MakeSelfSalonOwnerInput = {
	/** 実際には使用しないダミー。GraphQL の input 型は最低 1 フィールド必要なため置いている。指定不要。 */
	dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** MakeSelfSalonOwner mutation のレスポンス。 */
export type MakeSelfSalonOwnerResponse = {
	ok: Scalars["Boolean"]["output"]
}

export type Me = {
	/**
	 * Currently logged in salon
	 * - [現在ログイン中の定義]
	 *   - Rh-Salon-Id がある場合: その店舗
	 *   - Rh-Salon-Id がない場合: 一番最近 Login or SwitchSalon を叩いた店舗。なければ、アクセス可能な店舗の中で一番 salonId が小さい店舗
	 */
	salon: Salon
	/** Currently logged in salon detail (Federation Entity - extended by cancy) */
	salonDetail: SalonDetail
	/** Currently logged in user */
	salonUser: SalonUser
	/** Salons that the currently logged in user has permission for */
	salons: Array<Salon>
}

/** TODO: add description */
export type Mutation = {
	abortClaim: Cancel
	activateCouponMaster: CouponMaster
	bulkUpdateCancelPaymentStatus: Array<Cancel>
	/** 複数のキャンセルに対してキャンセル料の請求を一括送信する。 */
	bundleClaim: BundleClaimResponse
	createCancel: CreateCancelPayload
	createCouponMaster: CreateCouponMasterPayload
	deactivateCouponMaster: CouponMaster
	deactivateCouponMasterV2: DeactivateCouponMasterPayload
	deleteSalonUser: DeleteSalonUserResponse
	inviteSalonUser: InviteSalonUserResponse
	loadCancels: LoadCancelsPayload
	/**
	 * Login process
	 * If salonId is not specified, login to the first salon the user has permission for
	 */
	login: Me
	makeSelfSalonOwner: MakeSelfSalonOwnerResponse
	scheduleEncourageRereservation: ScheduleEncourageRereservationResponse
	sendInvoice: Cancel
	/** Switch salon */
	switchSalon: Me
	switchSalonOwner: SwitchSalonOwnerResponse
	updateCancel: Cancel
	updateCancelForRereservation: Cancel
	updateDefaultCouponMasterSetting: Salon
	updateSalon: UpdateSalonResponse
	updateSalonUserRole: UpdateSalonUserRoleResponse
	updateScrapingTargetSiteSetting: UpdateScrapingTargetSiteSettingResponse
	upsertClaimRule: ClaimRule
}

/** TODO: add description */
export type MutationAbortClaimArgs = {
	input: AbortClaimInput
}

/** TODO: add description */
export type MutationActivateCouponMasterArgs = {
	input: ActivateCouponMasterInput
}

/** TODO: add description */
export type MutationBulkUpdateCancelPaymentStatusArgs = {
	input: BulkUpdateCancelPaymentStatusInput
}

/** TODO: add description */
export type MutationBundleClaimArgs = {
	input: BundleClaimInput
}

/** TODO: add description */
export type MutationCreateCancelArgs = {
	input: CreateCancelInput
}

/** TODO: add description */
export type MutationCreateCouponMasterArgs = {
	input: CouponMasterInput
}

/** TODO: add description */
export type MutationDeactivateCouponMasterArgs = {
	input: DeactivateCouponMasterInput
}

/** TODO: add description */
export type MutationDeactivateCouponMasterV2Args = {
	input: DeactivateCouponMasterInput
}

/** TODO: add description */
export type MutationDeleteSalonUserArgs = {
	input: DeleteSalonUserInput
}

/** TODO: add description */
export type MutationInviteSalonUserArgs = {
	input: InviteSalonUserInput
}

/** TODO: add description */
export type MutationLoadCancelsArgs = {
	input: LoadCancelsInput
}

/** TODO: add description */
export type MutationLoginArgs = {
	salonId: InputMaybe<Scalars["Int"]["input"]>
}

/** TODO: add description */
export type MutationMakeSelfSalonOwnerArgs = {
	input: MakeSelfSalonOwnerInput
}

/** TODO: add description */
export type MutationScheduleEncourageRereservationArgs = {
	input: ScheduleEncourageRereservationInput
}

/** TODO: add description */
export type MutationSendInvoiceArgs = {
	input: SendInvoiceInput
}

/** TODO: add description */
export type MutationSwitchSalonArgs = {
	salonId: Scalars["Int"]["input"]
}

/** TODO: add description */
export type MutationSwitchSalonOwnerArgs = {
	input: SwitchSalonOwnerInput
}

/** TODO: add description */
export type MutationUpdateCancelArgs = {
	input: UpdateCancelInput
}

/** TODO: add description */
export type MutationUpdateCancelForRereservationArgs = {
	input: UpdateCancelForRereservationInput
}

/** TODO: add description */
export type MutationUpdateDefaultCouponMasterSettingArgs = {
	input: UpdateDefaultCouponMasterSettingInput
}

/** TODO: add description */
export type MutationUpdateSalonArgs = {
	input: UpdateSalonInput
}

/** TODO: add description */
export type MutationUpdateSalonUserRoleArgs = {
	input: UpdateSalonUserRoleInput
}

/** TODO: add description */
export type MutationUpdateScrapingTargetSiteSettingArgs = {
	input: UpdateScrapingTargetSiteSettingInput
}

/** TODO: add description */
export type MutationUpsertClaimRuleArgs = {
	input: UpsertClaimRuleInput
}

/**
 * スクレイピング対象サイトの設定がない場合
 * - message: スクレイピング対象サイトの設定がない場合のメッセージ
 *     - 例: "連携媒体が設定されていません"
 */
export type NoneScrapingTargetSiteSetting = {
	message: Scalars["String"]["output"]
}

/** 未請求通知ログIDを指定して、そのログに紐づく displayed_cancel_ids（キャンセルID配列）を取得する */
export type NotClaimedCancelsNotificationLogDisplayedCancelIdsParam = {
	/** 未請求通知ログのID */
	id: Scalars["String"]["input"]
}

/** 未請求通知ログに紐づくキャンセルID一覧のレスポンス */
export type NotClaimedCancelsNotificationLogDisplayedCancelIdsResponse = {
	/** 通知に含まれるキャンセルIDの配列 */
	displayedCancelIds: Array<Scalars["String"]["output"]>
}

/**
 * NotClaimedCancelsResponse は、未請求キャンセルのレスポンスを表す。
 *
 * - cancels: 未請求キャンセルリスト
 */
export type NotClaimedCancelsResponse = {
	cancels: Array<Cancel>
}

/**
 * NotSubjectCancelsResponse は、請求対象外キャンセルのレスポンスを表す。
 *
 * - cancels: 請求対象外キャンセルリスト
 */
export type NotSubjectCancelsResponse = {
	cancels: Array<Cancel>
}

/**
 * PaidCancelsResponse は、支払済キャンセルのレスポンスを表す。
 *
 * - cancels: 支払済キャンセルリスト
 */
export type PaidCancelsResponse = {
	cancels: Array<Cancel>
}

/** ピークマネージャーとサロンボードの設定 */
export type PeakManagerAndSalonboardSetting = {
	peakManagerSetting: PeakManagerSetting
	salonboardSetting: SalonboardSetting
}

/** ピークマネージャーの設定 */
export type PeakManagerSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithOnlyId: ScrapingTargetSiteSettingFieldsWithOnlyId
}

/**
 * [header]
 * - Authorization: Bearer <service_token>
 *   - 必須 (idp Check により作成)
 * - Rh-Salon-Id: <salon_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 * - Rh-User-Id: <user_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 *
 * [auth]
 * - TODO: add description
 */
export type Query = {
	/** CancelType の 表示用テキストを一覧で返します */
	cancelTypeInfo: Array<CancelTypeInfo>
	claimRule: ClaimRule
	claimedCancels: ClaimedCancelsResponse
	/** 現在ログインしているサロンが所属するcompanyを取得します */
	company: Company
	couponMasters: Array<CouponMaster>
	encourageRereservationMessageNotSentCancels: EncourageRereservationMessageNotSentCancelsResponse
	encourageRereservationMessageSentCancels: EncourageRereservationMessageSentCancelsResponse
	hello: Scalars["String"]["output"]
	invoicePrice: InvoicePriceResponse
	latestCouponMaster: Maybe<CouponMaster>
	me: Me
	notClaimedCancels: NotClaimedCancelsResponse
	notClaimedCancelsNotificationLogDisplayedCancelIds: NotClaimedCancelsNotificationLogDisplayedCancelIdsResponse
	notSubjectCancels: NotSubjectCancelsResponse
	paidCancels: PaidCancelsResponse
	rereservedCancels: RereservedCancelsResponse
	salonUsers: Array<SalonUser>
	/** 現在ログインしているサロンのスクレイピング対象サイトの設定を取得します */
	scrapingTargetSiteSetting: ScrapingTargetSiteSetting
	/**
	 * DO NOT call this query.
	 * this field is not for executing query, but only for showing possible UserErrorCode enum value to frontend client.
	 */
	userErrorCode: UserErrorCode
}

/**
 * [header]
 * - Authorization: Bearer <service_token>
 *   - 必須 (idp Check により作成)
 * - Rh-Salon-Id: <salon_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 * - Rh-User-Id: <user_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 *
 * [auth]
 * - TODO: add description
 */
export type QueryCouponMastersArgs = {
	param: CouponMastersParam
}

/**
 * [header]
 * - Authorization: Bearer <service_token>
 *   - 必須 (idp Check により作成)
 * - Rh-Salon-Id: <salon_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 * - Rh-User-Id: <user_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 *
 * [auth]
 * - TODO: add description
 */
export type QueryInvoicePriceArgs = {
	param: InvoicePriceParam
}

/**
 * [header]
 * - Authorization: Bearer <service_token>
 *   - 必須 (idp Check により作成)
 * - Rh-Salon-Id: <salon_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 * - Rh-User-Id: <user_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 *
 * [auth]
 * - TODO: add description
 */
export type QueryLatestCouponMasterArgs = {
	salonId?: InputMaybe<Scalars["Int"]["input"]>
}

/**
 * [header]
 * - Authorization: Bearer <service_token>
 *   - 必須 (idp Check により作成)
 * - Rh-Salon-Id: <salon_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 * - Rh-User-Id: <user_id>
 *   - Login, me 意外では渡されることを想定。渡されなければ、エラーになる可能性あり
 *
 * [auth]
 * - TODO: add description
 */
export type QueryNotClaimedCancelsNotificationLogDisplayedCancelIdsArgs = {
	param: NotClaimedCancelsNotificationLogDisplayedCancelIdsParam
}

export type RecentLoadCancelsResult = {
	/** 最後に LoadCancels mutation でIDかパスワードがエラーだった時間 */
	lastIdOrPasswordErrorTime: Maybe<Scalars["DateTime"]["output"]>
	/** 最後に LoadCancels mutation が成功、または UpdateScrapingTargetSiteSetting mutation が成功した時間 */
	lastLoadCancelsOrUpdateScrapingTargetSiteSettingSuccessTime: Maybe<
		Scalars["DateTime"]["output"]
	>
}

export type Rereservation = {
	cancelId: Scalars["String"]["output"]
	couponNames: Array<Scalars["String"]["output"]>
	discountPrice: Maybe<Scalars["Int"]["output"]>
	durationMinute: Scalars["Int"]["output"]
	menuNames: Array<Scalars["String"]["output"]>
	price: Scalars["Int"]["output"]
	/** deprecated. use staff_name instead. */
	salonStaffId: Maybe<Scalars["String"]["output"]>
	scrapingTargetSiteReserveId: Scalars["String"]["output"]
	/** deprecated. use staff_name instead. */
	staff: Maybe<SalonStaff>
	staffName: Scalars["String"]["output"]
	startTime: Scalars["DateTime"]["output"]
}

/**
 * RereservedCancelsResponse は、再予約済キャンセルのレスポンスを表す。
 *
 * - cancels: 再予約済キャンセルリスト
 */
export type RereservedCancelsResponse = {
	cancels: Array<Cancel>
}

export type Role = "ADMIN" | "MEMBER" | "OWNER"

/** Salon (Federation Entity - returns ID, name, displayName, address, userPermission) */
export type Salon = {
	address: Scalars["String"]["output"]
	canEnqueueSyncCancels: Scalars["Boolean"]["output"]
	defaultCouponMaster: Maybe<CouponMaster>
	defaultSelectedCancelTypeForCreatingCancel: CreateCancelCancelTypeInput
	displayName: Scalars["String"]["output"]
	enableDefaultCouponMasterForNoConfirmationCancel: Scalars["Boolean"]["output"]
	featureFlag: FeatureFlag
	id: Scalars["Int"]["output"]
	/**
	 * Cancel.hasLapsedAfterCancel による離脱顧客ハイライト（赤ハイライト・凡例）を出してよい店舗かどうか。
	 *
	 * - 送付ルールに再予約転換 unit を持つ店舗（再予約機能 on）は false
	 * - それ以外は true
	 *
	 * Cancel.hasLapsedAfterCancel 自体は店舗設定に関係なく離脱したかどうかの事実を返すので、
	 * FE はこの値と AND を取ってハイライト有無を決める。
	 */
	isLapsedAfterCancelHighlightEnabled: Scalars["Boolean"]["output"]
	/** deprecated: it's ok to delete */
	isYesterdayCancelNoFee: Scalars["Boolean"]["output"]
	/**
	 * Cancel.hasLapsedAfterCancel が true になるまでに来店予定日から経過している必要がある日数。
	 *
	 * - 通常は 5（来店予定日を含めて6日目以降が離脱扱い）
	 * - feature flag LAPSED_AFTER_CANCEL_3_DAYS_AFTER が有効なサロンは 3（同4日目以降）
	 *
	 * FE の「請求を推奨する離脱顧客」の説明文に出す日数として使う。
	 */
	lapsedAfterCancelMinDays: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
	/**
	 * NO_ENCOURAGING_CLAIMING_CONVERSION の待機日数設定。
	 * キャンセル作成から何日後に請求転換するかを表す。
	 *
	 * - 対象サロン（special_salons.py の no_encouraging_claiming_conversion_salon_ids に含まれる）: 日数を返す（例: 1）
	 * - 非対象サロン: null を返す
	 * - null の場合、このサロンは NO_ENCOURAGING_CLAIMING_CONVERSION の対象外であることを意味する
	 */
	noEncouragingClaimingConversionDays: Maybe<Scalars["Int"]["output"]>
	/** deprecated: it's ok to delete */
	selectableCancelTypes: Array<CancelType>
	selectableCancelTypesWithoutUnspecifiedOnes: Array<CancelType>
	userPermission: UserPermission
}

/** サロンアンサーとサロンボードの設定 */
export type SalonAnswerAndSalonboardSetting = {
	salonAnswerSetting: SalonAnswerSetting
	salonboardSetting: SalonboardSetting
}

/** サロンアンサーの設定 */
export type SalonAnswerSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithStoreIdAndBaseUrl: ScrapingTargetSiteSettingFieldsWithStoreIdAndBaseUrl
}

/**
 * サロンコネクトの設定
 * - salonboard_setting は、サロンボードの設定。設定は任意で、これが設定されている場合は、スマート支払いをキャンセル一覧から除外できる。
 */
export type SalonConnectSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	salonboardSetting: Maybe<SalonboardSetting>
	settingFieldsWithOnlyId: ScrapingTargetSiteSettingFieldsWithOnlyId
}

/** SalonDetail (Federation Entity - returns only ID; extended by cancy for additional fields) */
export type SalonDetail = {
	id: Scalars["Int"]["output"]
	/**
	 * 予約スクレイピングが有効かつ昨日以降のスクレイピングログがあるかを判定する。
	 * 以下の全条件を満たす場合に True:
	 * - 連携媒体が予約の取得を行なっている
	 * - 昨日以降のスクレイピングログがある
	 * - OVERBOOKED_SALON_IDS に含まれない
	 */
	isReservationScrapingActive: Scalars["Boolean"]["output"]
}

export type SalonStaff = {
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
	scrapingTargetSiteStaffId: Scalars["String"]["output"]
}

/** Salon user */
export type SalonUser = {
	createTime: Scalars["DateTime"]["output"]
	email: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
	lastLoginTime: Maybe<Scalars["DateTime"]["output"]>
	role: Role
}

/**
 * サロンボードの設定
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はnullが帰る
 */
export type SalonboardSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithOptionalStoreId: ScrapingTargetSiteSettingFieldsWithOptionalStoreId
}

/** サロンボードとサロンズソリューションの設定 */
export type SalonsSolutionAndSalonboardSetting = {
	salonboardSetting: SalonboardSetting
	salonsSolutionSetting: SalonsSolutionSetting
}

/** サロンソリューションの設定 */
export type SalonsSolutionSetting = {
	recentLoadCancelsResult: RecentLoadCancelsResult
	settingFieldsWithStoreAndBaseUrl: ScrapingTargetSiteSettingFieldsWithStoreIdAndBaseUrl
}

/**
 * ScheduleEncourageRereservation mutation は、再予約促進メッセージの送信をスケジュールする。
 *
 * [error]
 * - ALREADY_RERESERVED_ERROR: すでに再予約済みの場合
 */
export type ScheduleEncourageRereservationInput = {
	cancelId: Scalars["String"]["input"]
}

export type ScheduleEncourageRereservationResponse = {
	cancel: Cancel
}

/** スクレイピング対象サイトの設定 */
export type ScrapingTargetSiteSetting = {
	salonId: Scalars["Int"]["output"]
	scrapingTargetSiteSettingUnion: ScrapingTargetSiteSettingUnion
}

export type ScrapingTargetSiteSettingFieldsWithBaseUrl = {
	baseUrl: Scalars["String"]["output"]
	baseUrlPlaceholder: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
}

export type ScrapingTargetSiteSettingFieldsWithOnlyId = {
	id: Scalars["String"]["output"]
}

export type ScrapingTargetSiteSettingFieldsWithOptionalStoreId = {
	id: Scalars["String"]["output"]
	storeId: Maybe<Scalars["String"]["output"]>
}

export type ScrapingTargetSiteSettingFieldsWithStoreIdAndBaseUrl = {
	baseUrl: Scalars["String"]["output"]
	baseUrlPlaceholder: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
	storeId: Scalars["String"]["output"]
}

export type ScrapingTargetSiteSettingInputFieldsWithBaseUrl = {
	baseUrl: Scalars["String"]["input"]
	id: Scalars["String"]["input"]
	password: Scalars["String"]["input"]
}

export type ScrapingTargetSiteSettingInputFieldsWithOnlyId = {
	id: Scalars["String"]["input"]
	password: Scalars["String"]["input"]
}

export type ScrapingTargetSiteSettingInputFieldsWithOptionalStoreId = {
	id: Scalars["String"]["input"]
	password: Scalars["String"]["input"]
	storeId?: InputMaybe<Scalars["String"]["input"]>
}

export type ScrapingTargetSiteSettingInputFieldsWithStoreIdAndBaseUrl = {
	baseUrl: Scalars["String"]["input"]
	id: Scalars["String"]["input"]
	password: Scalars["String"]["input"]
	storeId: Scalars["String"]["input"]
}

export type ScrapingTargetSiteSettingUnion =
	| BeautyMeritSetting
	| EparkAndSalonboardSetting
	| KanzashiSetting
	| KireipassConnectSetting
	| NoneScrapingTargetSiteSetting
	| PeakManagerAndSalonboardSetting
	| SalonAnswerAndSalonboardSetting
	| SalonAnswerSetting
	| SalonConnectSetting
	| SalonboardSetting
	| SalonsSolutionAndSalonboardSetting

/** SendInvoice mutation は、キャンセル料の請求を送信する。 */
export type SendInvoiceInput = {
	cancelId: Scalars["String"]["input"]
}

/**
 * SwitchSalonOwner mutation は、サロンオーナーを変更する。
 * - 指定されたユーザーにオーナー権限を付与
 * - 前オーナーの権限を admin にする
 *
 * [error]
 * - TODO: 具体的なエラー名
 * - PERMISSION_DENIED_ERROR: 権限不足
 * - Unexpected Error: 以下のいずれかの場合
 *   - 指定されたユーザーが現在ログインしているサロンに所属していない
 *   - 指定されたユーザーのuser_salon_mappingのlast_login_timeがNone
 */
export type SwitchSalonOwnerInput = {
	userId: Scalars["String"]["input"]
}

export type SwitchSalonOwnerResponse = {
	ok: Scalars["Boolean"]["output"]
}

/**
 * ビューティメリットの設定
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はあってもなくてもよいが、保存はされない
 * - salonboard_setting_input は、サロンボードの設定。設定は任意で、これが設定されている場合は、スマート支払いをキャンセル一覧から除外できる。
 */
export type UpdateBeautyMeritSettingInput = {
	salonboardSettingInput?: InputMaybe<UpdateSalonboardSettingInput>
	settingInputFieldsWithOptionalStoreId: ScrapingTargetSiteSettingInputFieldsWithOptionalStoreId
}

/**
 * UpdateCancelForRereservation mutation は、キャンセルの再予約用情報を更新する。
 *
 * [error]
 * - Unexpected Error: 存在しないキャンセル
 */
export type UpdateCancelForRereservationInput = {
	id: Scalars["String"]["input"]
	phoneNumber: Scalars["String"]["input"]
}

/**
 * UpdateCancel mutation は、キャンセルの情報を更新する。
 *
 * [error]
 * - Unexpected Error: 存在しない、もしくはサロンの異なるcoupon_master_id
 */
export type UpdateCancelInput = {
	cancelType: CancelType
	couponMasterId?: InputMaybe<Scalars["String"]["input"]>
	id: Scalars["String"]["input"]
	name?: Scalars["String"]["input"]
	originPrice: Scalars["Int"]["input"]
	phoneNumber: Scalars["String"]["input"]
}

/**
 * UpdateDefaultCouponMasterSetting mutation は、デフォルトクーポンの設定を更新する。
 * - 無断キャンセルもデフォルトクーポン適用するかも設定する
 * - inputについて: 一旦これでも問題なさそうだが、二つを更新するapiは別々にした方が意図しない動作がないきがした
 *
 * [error]
 * - Unexpected Error: 非表示状態のクーポンを指定した場合
 */
export type UpdateDefaultCouponMasterSettingInput = {
	couponMasterId?: InputMaybe<Scalars["String"]["input"]>
	enableDefaultCouponMasterForNoConfirmationCancel: Scalars["Boolean"]["input"]
}

/** エパークとサロンボードの設定 */
export type UpdateEparkAndSalonboardSettingInput = {
	eparkSettingInput: UpdateEparkSettingInput
	salonboardSettingInput: UpdateSalonboardSettingInput
}

/** エパークの設定 */
export type UpdateEparkSettingInput = {
	settingInputFieldsWithBaseUrl: ScrapingTargetSiteSettingInputFieldsWithBaseUrl
}

/**
 * かんざしの設定
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はあってもなくてもよいが、保存はされない
 */
export type UpdateKanzashiSettingInput = {
	settingInputFieldsWithOptionalStoreId: ScrapingTargetSiteSettingInputFieldsWithOptionalStoreId
}

/** キレイパスコネクトの設定 */
export type UpdateKireipassConnectSettingInput = {
	settingInputFieldsWithOnlyId: ScrapingTargetSiteSettingInputFieldsWithOnlyId
}

/** ピークマネージャーとサロンボードの設定 */
export type UpdatePeakManagerAndSalonboardSettingInput = {
	peakManagerSettingInput: UpdatePeakManagerSettingInput
	salonboardSettingInput: UpdateSalonboardSettingInput
}

/** ピークマネージャーの設定 */
export type UpdatePeakManagerSettingInput = {
	settingInputFieldsWithOnlyId: ScrapingTargetSiteSettingInputFieldsWithOnlyId
}

/** サロンアンサーとサロンボードの設定 */
export type UpdateSalonAnswerAndSalonboardSettingInput = {
	salonAnswerSettingInput: UpdateSalonAnswerSettingInput
	salonboardSettingInput: UpdateSalonboardSettingInput
}

/** サロンアンサーの設定 */
export type UpdateSalonAnswerSettingInput = {
	settingInputFieldsWithStoreIdAndBaseUrl: ScrapingTargetSiteSettingInputFieldsWithStoreIdAndBaseUrl
}

/**
 * サロンコネクトの設定
 * - salonboard_setting_input は、サロンボードの設定。設定は任意で、これが設定されている場合は、スマート支払いをキャンセル一覧から除外できる。
 */
export type UpdateSalonConnectSettingInput = {
	salonboardSettingInput?: InputMaybe<UpdateSalonboardSettingInput>
	settingInputFieldsWithOnlyId: ScrapingTargetSiteSettingInputFieldsWithOnlyId
}

/** UpdateSalon mutation は、サロンの基本情報を更新する。 */
export type UpdateSalonInput = {
	address: Scalars["String"]["input"]
	displayName: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
}

export type UpdateSalonResponse = {
	salon: Salon
}

/**
 * UpdateSalonUserRole mutation は、サロンユーザーのロールを更新する。
 *
 * [error]
 * - TODO: 具体的なエラー名
 * - PERMISSION_DENIED_ERROR: 権限不足
 * - Unexpected Error: 以下のいずれかの場合
 *   - 指定されたユーザーが現在ログインしているサロンに所属していない
 *   - サロンオーナーのロールを変更しようとした
 *   - MEMBERまたはADMIN以外のロールを指定した
 */
export type UpdateSalonUserRoleInput = {
	role: Role
	userId: Scalars["String"]["input"]
}

export type UpdateSalonUserRoleResponse = {
	salonUser: SalonUser
}

/**
 * スクレイピング対象サイトの設定一覧
 * - store_id は、HPBの店舗IDで、グループアカウントの場合は必須。そうでない場合はあってもなくてもよいが、保存はされない
 */
export type UpdateSalonboardSettingInput = {
	settingInputFieldsWithOptionalStoreId: ScrapingTargetSiteSettingInputFieldsWithOptionalStoreId
}

/** サロンズソリューションとサロンボードの設定 */
export type UpdateSalonsSolutionAndSalonboardSettingInput = {
	salonboardSettingInput: UpdateSalonboardSettingInput
	salonsSolutionSettingInput: UpdateSalonsSolutionSettingInput
}

/** サロンソリューションの設定 */
export type UpdateSalonsSolutionSettingInput = {
	settingInputFieldsWithStoreAndBaseUrl: ScrapingTargetSiteSettingInputFieldsWithStoreIdAndBaseUrl
}

/**
 * スクレイピング対象サイトの設定更新用Input
 * TODO: scrpaing logも作成。どうするか考える
 *
 * [error]
 * - INVALID_SCRAPING_TARGET_SITE_SETTING_ERROR: 以下のいずれかの場合
 *     - グループアカウントなのにも関わらず、store_id が指定されていない
 *     - id, password, (媒体によっては加えて store_id, base_url) の組が正しくない
 * - BAD_REQUEST_ERROR: 以下のいずれかの場合
 *     - UpdateScrapingTargetSiteSettingInputUnion でoptionalでないフィールドが一つではない
 *     - UpdateScrapingTargetSiteSettingInputUnion で指定された媒体が、このサロンに登録されている媒体ではない
 */
export type UpdateScrapingTargetSiteSettingInput = {
	salonId: Scalars["Int"]["input"]
	scrapingTargetSiteSettingInputUnion: UpdateScrapingTargetSiteSettingInputUnion
}

export type UpdateScrapingTargetSiteSettingInputUnion = {
	updateBeautyMeritSettingInput?: InputMaybe<UpdateBeautyMeritSettingInput>
	updateEparkAndSalonboardSettingInput?: InputMaybe<UpdateEparkAndSalonboardSettingInput>
	updateKanzashiSettingInput?: InputMaybe<UpdateKanzashiSettingInput>
	updateKireipassConnectSettingInput?: InputMaybe<UpdateKireipassConnectSettingInput>
	updatePeakManagerAndSalonboardSettingInput?: InputMaybe<UpdatePeakManagerAndSalonboardSettingInput>
	updateSalonAnswerAndSalonboardSettingInput?: InputMaybe<UpdateSalonAnswerAndSalonboardSettingInput>
	updateSalonConnectSettingInput?: InputMaybe<UpdateSalonConnectSettingInput>
	updateSalonboardSettingInput?: InputMaybe<UpdateSalonboardSettingInput>
	updateSalonsSolutionAndSalonboardSettingInput?: InputMaybe<UpdateSalonsSolutionAndSalonboardSettingInput>
}

export type UpdateScrapingTargetSiteSettingResponse = {
	scrapingTargetSiteSetting: ScrapingTargetSiteSetting
}

export type UpsertClaimRuleInput = {
	text: Scalars["String"]["input"]
}

/**
 * エラーが起きた際、ユーザー側で解決可能なエラーのときは
 * extensions.code でエラーコードを返し、message で human readable なエラーメッセージを返す。
 * その際、取り得るエラーコードがUserErrorCodeである。
 *
 * - フロントエンドにどんなエラーコード文字列が返りうるかを一覧で伝えるため、型定義をしているが、UserErrorCodeという型を返すAPI自体があるわけではない。
 */
export type UserErrorCode =
	| "ALREADY_RERESERVED"
	| "BAD_REQUEST"
	| "CANNOT_RESERVE_MENU_OR_COUPON"
	| "INVALID_BEAUTY_MERIT_ID_OR_PASSWORD"
	| "INVALID_EPARK_ID_OR_PASSWORD"
	| "INVALID_KANZASHI_ID_OR_PASSWORD"
	| "INVALID_KIREIPASS_CONNECT_ID_OR_PASSWORD"
	| "INVALID_MINIMO_ID_OR_PASSWORD"
	| "INVALID_PEAK_MANAGER_ID_OR_PASSWORD"
	| "INVALID_POSTAS_ID_OR_PASSWORD"
	| "INVALID_RAKUTEN_ID_OR_PASSWORD"
	| "INVALID_SALONBOARD_ID_OR_PASSWORD"
	| "INVALID_SALON_ANSWER_ID_OR_PASSWORD"
	| "INVALID_SALON_CONNECT_ID_OR_PASSWORD"
	| "INVALID_SALON_SOLUTION_ID_OR_PASSWORD"
	| "INVALID_SALORIZA_ID_OR_PASSWORD"
	| "INVALID_SCRAPING_TARGET_SITE_SETTING"
	| "PERMISSION_DENIED"
	| "SALON_ANSWER_FORCE_LOGOUT"

export type UserPermission = {
	canActivateCouponMaster: Scalars["Boolean"]["output"]
	canCreateCouponMaster: Scalars["Boolean"]["output"]
	canDeactivateCouponMaster: Scalars["Boolean"]["output"]
	canDeleteSalonUser: Scalars["Boolean"]["output"]
	canInviteSalonUser: Scalars["Boolean"]["output"]
	canSwitchSalonOwner: Scalars["Boolean"]["output"]
	canUpdateDefaultCouponMasterSetting: Scalars["Boolean"]["output"]
	canUpdateSalon: Scalars["Boolean"]["output"]
	canUpdateSalonUserRole: Scalars["Boolean"]["output"]
	canUpsertClaimRule: Scalars["Boolean"]["output"]
	isSouhlAdmin: Scalars["Boolean"]["output"]
	role: Role
	salonId: Scalars["Int"]["output"]
}

export type Join__Graph = "CANCY_STORE_MANAGEMENT" | "IDP_STORE_MANAGEMENT"

export type Link__Purpose =
	/** `EXECUTION` features provide metadata necessary for operation execution. */
	| "EXECUTION"
	/** `SECURITY` features provide metadata necessary to securely resolve fields. */
	| "SECURITY"

export type CouponMasterNameFragment = { id: string; name: string } & {
	" $fragmentName"?: "CouponMasterNameFragment"
}

export type UseUserPermissionFragment = {
	canUpdateSalon: boolean
	canUpsertClaimRule: boolean
	canCreateCouponMaster: boolean
	canUpdateSalonUserRole: boolean
	canSwitchSalonOwner: boolean
	isSouhlAdmin: boolean
	canInviteSalonUser: boolean
	canDeleteSalonUser: boolean
	canActivateCouponMaster: boolean
	canDeactivateCouponMaster: boolean
	canUpdateDefaultCouponMasterSetting: boolean
} & { " $fragmentName"?: "UseUserPermissionFragment" }

export type UseFeatureFlagFragment = {
	salonId: number
	isEncouragingRereservationEnabled: boolean
	forceEmptyWhenCannotReserveCanceledReservationMenuSet: boolean
} & { " $fragmentName"?: "UseFeatureFlagFragment" }

export type SalonAllFieldFragment = {
	id: number
	name: string
	displayName: string
	address: string
	canEnqueueSyncCancels: boolean
	enableDefaultCouponMasterForNoConfirmationCancel: boolean
	selectableCancelTypes: Array<CancelType>
	selectableCancelTypesWithoutUnspecifiedOnes: Array<CancelType>
	defaultSelectedCancelTypeForCreatingCancel: CreateCancelCancelTypeInput
	lapsedAfterCancelMinDays: number
	defaultCouponMaster: {
		" $fragmentRefs"?: { CouponMasterNameFragment: CouponMasterNameFragment }
	} | null
	userPermission: {
		" $fragmentRefs"?: { UseUserPermissionFragment: UseUserPermissionFragment }
	}
	featureFlag: {
		" $fragmentRefs"?: { UseFeatureFlagFragment: UseFeatureFlagFragment }
	}
} & { " $fragmentName"?: "SalonAllFieldFragment" }

export type SalonUserAllFieldFragment = {
	id: string
	email: string
	role: Role
	lastLoginTime: string | null
	createTime: string
} & { " $fragmentName"?: "SalonUserAllFieldFragment" }

export type SalonNameFragment = {
	id: number
	name: string
	displayName: string
} & { " $fragmentName"?: "SalonNameFragment" }

export type SalonDetailFieldFragment = {
	id: number
	isReservationScrapingActive: boolean
} & { " $fragmentName"?: "SalonDetailFieldFragment" }

export type GetMeQueryVariables = Exact<{ [key: string]: never }>

export type GetMeQuery = {
	me: {
		salon: {
			" $fragmentRefs"?: { SalonAllFieldFragment: SalonAllFieldFragment }
		}
		salonDetail: {
			" $fragmentRefs"?: { SalonDetailFieldFragment: SalonDetailFieldFragment }
		}
		salons: Array<{
			" $fragmentRefs"?: { SalonNameFragment: SalonNameFragment }
		}>
		salonUser: {
			" $fragmentRefs"?: {
				SalonUserAllFieldFragment: SalonUserAllFieldFragment
			}
		}
	}
}

export type SwitchSalonMutationVariables = Exact<{
	salonId: Scalars["Int"]["input"]
}>

export type SwitchSalonMutation = { switchSalon: { salon: { id: number } } }

export type LoginMutationVariables = Exact<{
	salonId: InputMaybe<Scalars["Int"]["input"]>
}>

export type LoginMutation = {
	login: {
		salon: {
			" $fragmentRefs"?: { SalonAllFieldFragment: SalonAllFieldFragment }
		}
		salons: Array<{
			" $fragmentRefs"?: { SalonNameFragment: SalonNameFragment }
		}>
		salonUser: {
			" $fragmentRefs"?: {
				SalonUserAllFieldFragment: SalonUserAllFieldFragment
			}
		}
	}
}

export type GetClaimRuleQueryVariables = Exact<{ [key: string]: never }>

export type GetClaimRuleQuery = { claimRule: { id: number; text: string } }

export type UpsertClaimRuleMutationVariables = Exact<{
	input: UpsertClaimRuleInput
}>

export type UpsertClaimRuleMutation = {
	upsertClaimRule: { id: number; text: string }
}

export type GetCouponMastersQueryVariables = Exact<{
	param: CouponMastersParam
}>

export type GetCouponMastersQuery = {
	couponMasters: Array<{
		" $fragmentRefs"?: {
			CouponMasterForListFragment: CouponMasterForListFragment
		}
	}>
}

export type CouponMasterForListFragment = {
	id: string
	name: string
	targetName: string
	discountAmount: number | null
	discountPercent: number | null
	expireDurationDay: number
	minAmount: number
	cancelsAttachedToCouponMaster: {
		relationSummary: {
			invoiceCount: number
			issuedCount: number
			usedCount: number
		}
	}
} & { " $fragmentName"?: "CouponMasterForListFragment" }

export type ActivateCouponMasterMutationVariables = Exact<{
	input: ActivateCouponMasterInput
}>

export type ActivateCouponMasterMutation = {
	activateCouponMaster: { id: string }
}

export type DeactivateCouponMasterV2MutationVariables = Exact<{
	input: DeactivateCouponMasterInput
}>

export type DeactivateCouponMasterV2Mutation = {
	deactivateCouponMasterV2: {
		salon: {
			" $fragmentRefs"?: { SalonAllFieldFragment: SalonAllFieldFragment }
		}
	}
}

export type UpdateDefaultCouponMasterSettingMutationVariables = Exact<{
	input: UpdateDefaultCouponMasterSettingInput
}>

export type UpdateDefaultCouponMasterSettingMutation = {
	updateDefaultCouponMasterSetting: {
		" $fragmentRefs"?: { SalonAllFieldFragment: SalonAllFieldFragment }
	}
}

export type CreateCouponMasterMutationVariables = Exact<{
	input: CouponMasterInput
}>

export type CreateCouponMasterMutation = {
	createCouponMaster: {
		salon: {
			" $fragmentRefs"?: { SalonAllFieldFragment: SalonAllFieldFragment }
		}
	}
}

export type BundleClaimMutationVariables = Exact<{
	input: BundleClaimInput
}>

export type BundleClaimMutation = {
	bundleClaim: { failedCancelNames: Array<string> }
}

export type CouponMasterToSelectFragment = { id: string; name: string } & {
	" $fragmentName"?: "CouponMasterToSelectFragment"
}

export type GetInvoicePriceQueryVariables = Exact<{
	param: InvoicePriceParam
}>

export type GetInvoicePriceQuery = { invoicePrice: { invoicePrice: number } }

export type GetClaimedCancelsQueryVariables = Exact<{ [key: string]: never }>

export type GetClaimedCancelsQuery = {
	claimedCancels: {
		cancels: Array<{
			" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
		}>
	}
}

export type GetCouponMastersToSelectQueryVariables = Exact<{
	param: CouponMastersParam
}>

export type GetCouponMastersToSelectQuery = {
	couponMasters: Array<{
		" $fragmentRefs"?: {
			CouponMasterToSelectFragment: CouponMasterToSelectFragment
		}
	}>
}

export type GetNotClaimedCancelsQueryVariables = Exact<{ [key: string]: never }>

export type GetNotClaimedCancelsQuery = {
	notClaimedCancels: {
		cancels: Array<{
			" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
		}>
	}
}

export type GetPaidCancelsQueryVariables = Exact<{ [key: string]: never }>

export type GetPaidCancelsQuery = {
	paidCancels: {
		cancels: Array<{
			" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
		}>
	}
}

export type GetNotSubjectCancelsQueryVariables = Exact<{ [key: string]: never }>

export type GetNotSubjectCancelsQuery = {
	notSubjectCancels: {
		cancels: Array<{
			" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
		}>
	}
}

export type GetEncourageRereservationMessageNotSentCancelsQueryVariables =
	Exact<{ [key: string]: never }>

export type GetEncourageRereservationMessageNotSentCancelsQuery = {
	encourageRereservationMessageNotSentCancels: {
		cancels: Array<{
			" $fragmentRefs"?: {
				CancelForRereservationFragment: CancelForRereservationFragment
			}
		}>
	}
}

export type GetEncourageRereservationMessageSentCancelsQueryVariables = Exact<{
	[key: string]: never
}>

export type GetEncourageRereservationMessageSentCancelsQuery = {
	encourageRereservationMessageSentCancels: {
		cancels: Array<{
			" $fragmentRefs"?: {
				CancelForRereservationFragment: CancelForRereservationFragment
			}
		}>
	}
}

export type GetRereservedCancelsQueryVariables = Exact<{ [key: string]: never }>

export type GetRereservedCancelsQuery = {
	rereservedCancels: {
		cancels: Array<{
			" $fragmentRefs"?: {
				CancelForRereservationFragment: CancelForRereservationFragment
			}
		}>
	}
}

export type GetLapsedAfterCancelHighlightEnabledQueryVariables = Exact<{
	[key: string]: never
}>

export type GetLapsedAfterCancelHighlightEnabledQuery = {
	me: { salon: { id: number; isLapsedAfterCancelHighlightEnabled: boolean } }
}

export type CancelForListFragment = {
	id: number
	idv2: string
	salonId: number
	reserveId: string
	cancelType: CancelType
	paymentStatus: CancelPaymentStatus
	visitCounts: number
	isVisitCountInvalid: boolean
	reserveRoute: string
	originPrice: number
	invoicePrice: number
	name: string
	staffName: string | null
	paidTime: string | null
	phoneNumber: string
	dateVisit: string
	dateCancel: string | null
	cancelCouponMasterSpecifiedBy: CancelCouponMasterIdSpecifiedBy
	isCreatedByUi: boolean
	shouldUseDefaultCouponMaster: boolean
	hasLapsedAfterCancel: boolean
	couponMaster: {
		" $fragmentRefs"?: { CouponMasterNameFragment: CouponMasterNameFragment }
	} | null
} & { " $fragmentName"?: "CancelForListFragment" }

export type CancelForRereservationFragment = {
	idv2: string
	salonId: number
	reserveId: string
	cancelType: CancelType
	messageKind: CancelMessageKind
	rereservationStatus: CancelRereservationStatus
	visitCounts: number
	isVisitCountInvalid: boolean
	isCreatedByUi: boolean
	originPrice: number
	name: string
	staffName: string | null
	phoneNumber: string
	rereservedTime: string | null
	dateVisit: string
	dateCancel: string | null
	claimingConversionAppliedTime: string | null
	rereservation: {
		cancelId: string
		scrapingTargetSiteReserveId: string
		price: number
		discountPrice: number | null
		startTime: string
		staffName: string
		menuNames: Array<string>
		couponNames: Array<string>
		durationMinute: number
	} | null
} & { " $fragmentName"?: "CancelForRereservationFragment" }

export type UpdateCancelMutationVariables = Exact<{
	input: UpdateCancelInput
}>

export type UpdateCancelMutation = {
	updateCancel: {
		" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
	}
}

export type UpdateCancelForRereservationMutationVariables = Exact<{
	input: UpdateCancelForRereservationInput
}>

export type UpdateCancelForRereservationMutation = {
	updateCancelForRereservation: {
		" $fragmentRefs"?: { CancelForListFragment: CancelForListFragment }
	}
}

export type SendInvoiceMutationVariables = Exact<{
	input: SendInvoiceInput
}>

export type SendInvoiceMutation = {
	sendInvoice: { idv2: string; paymentId: string | null }
}

export type ScheduleEncourageRereservationMutationVariables = Exact<{
	input: ScheduleEncourageRereservationInput
}>

export type ScheduleEncourageRereservationMutation = {
	scheduleEncourageRereservation: { cancel: { idv2: string } }
}

export type AbortClaimMutationVariables = Exact<{
	input: AbortClaimInput
}>

export type AbortClaimMutation = { abortClaim: { idv2: string } }

export type BulkUpdateCancelPaymentStatusMutationVariables = Exact<{
	input: BulkUpdateCancelPaymentStatusInput
}>

export type BulkUpdateCancelPaymentStatusMutation = {
	bulkUpdateCancelPaymentStatus: Array<{
		id: number
		salonId: number
		reserveId: string
		cancelType: CancelType
		paymentStatus: CancelPaymentStatus
		visitCounts: number
		reserveRoute: string
		originPrice: number
		invoicePrice: number
		name: string
		phoneNumber: string
		dateVisit: string
		dateCancel: string | null
		isCouponEnabled: boolean
	}>
}

export type LoadCancelsMutationVariables = Exact<{
	input: LoadCancelsInput
}>

export type LoadCancelsMutation = { loadCancels: { ok: boolean } }

export type GetNotClaimedCancelsNotificationLogDisplayedCancelIdsQueryVariables =
	Exact<{
		param: NotClaimedCancelsNotificationLogDisplayedCancelIdsParam
	}>

export type GetNotClaimedCancelsNotificationLogDisplayedCancelIdsQuery = {
	notClaimedCancelsNotificationLogDisplayedCancelIds: {
		displayedCancelIds: Array<string>
	}
}

export type GetCouponMastersToCreateCancelQueryVariables = Exact<{
	param: CouponMastersParam
}>

export type GetCouponMastersToCreateCancelQuery = {
	couponMasters: Array<{ id: string; name: string }>
}

export type CreateCancelMutationVariables = Exact<{
	input: CreateCancelInput
}>

export type CreateCancelMutation = {
	createCancel: { cancel: { id: number; idv2: string } }
}

export type UpdateSalonMutationVariables = Exact<{
	input: UpdateSalonInput
}>

export type UpdateSalonMutation = {
	updateSalon: {
		salon: { id: number; name: string; displayName: string; address: string }
	}
}

export type GetSalonUsersQueryVariables = Exact<{ [key: string]: never }>

export type GetSalonUsersQuery = {
	salonUsers: Array<{
		" $fragmentRefs"?: { SalonUserAllFieldFragment: SalonUserAllFieldFragment }
	}>
}

export type UpdateSalonUserRoleMutationVariables = Exact<{
	input: UpdateSalonUserRoleInput
}>

export type UpdateSalonUserRoleMutation = {
	updateSalonUserRole: {
		salonUser: {
			" $fragmentRefs"?: {
				SalonUserAllFieldFragment: SalonUserAllFieldFragment
			}
		}
	}
}

export type SwitchSalonOwnerMutationVariables = Exact<{
	input: SwitchSalonOwnerInput
}>

export type SwitchSalonOwnerMutation = { switchSalonOwner: { ok: boolean } }

export type DeleteSalonUserMutationVariables = Exact<{
	input: DeleteSalonUserInput
}>

export type DeleteSalonUserMutation = { deleteSalonUser: { ok: boolean } }

export type InviteSalonUserMutationVariables = Exact<{
	input: InviteSalonUserInput
}>

export type InviteSalonUserMutation = { inviteSalonUser: { ok: boolean } }

export type MakeSelfSalonOwnerMutationVariables = Exact<{
	[key: string]: never
}>

export type MakeSelfSalonOwnerMutation = { makeSelfSalonOwner: { ok: boolean } }

export type GetCancelTypeInfosQueryVariables = Exact<{ [key: string]: never }>

export type GetCancelTypeInfosQuery = {
	cancelTypeInfo: Array<{ cancelType: CancelType; text: string }>
}

export const CouponMasterNameFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<CouponMasterNameFragment, unknown>
export const UseUserPermissionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<UseUserPermissionFragment, unknown>
export const UseFeatureFlagFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<UseFeatureFlagFragment, unknown>
export const SalonAllFieldFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SalonAllFieldFragment, unknown>
export const SalonUserAllFieldFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonUserAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonUser" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "email" } },
					{ kind: "Field", name: { kind: "Name", value: "role" } },
					{ kind: "Field", name: { kind: "Name", value: "lastLoginTime" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<SalonUserAllFieldFragment, unknown>
export const SalonNameFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
				],
			},
		},
	],
} as unknown as DocumentNode<SalonNameFragment, unknown>
export const SalonDetailFieldFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonDetailField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonDetail" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isReservationScrapingActive" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SalonDetailFieldFragment, unknown>
export const CouponMasterForListFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "targetName" } },
					{ kind: "Field", name: { kind: "Name", value: "discountAmount" } },
					{ kind: "Field", name: { kind: "Name", value: "discountPercent" } },
					{ kind: "Field", name: { kind: "Name", value: "expireDurationDay" } },
					{ kind: "Field", name: { kind: "Name", value: "minAmount" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelsAttachedToCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "relationSummary" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "invoiceCount" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "issuedCount" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "usedCount" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<CouponMasterForListFragment, unknown>
export const CouponMasterToSelectFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterToSelect" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<CouponMasterToSelectFragment, unknown>
export const CancelForListFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<CancelForListFragment, unknown>
export const CancelForRereservationFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForRereservation" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "messageKind" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationStatus" },
					},
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "rereservedTime" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionAppliedTime" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservation" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteReserveId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "price" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "discountPrice" },
								},
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{ kind: "Field", name: { kind: "Name", value: "staffName" } },
								{ kind: "Field", name: { kind: "Name", value: "menuNames" } },
								{ kind: "Field", name: { kind: "Name", value: "couponNames" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<CancelForRereservationFragment, unknown>
export const GetMeDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetMe" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "me" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonAllField" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salonDetail" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonDetailField" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonName" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salonUser" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonUserAllField" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonDetailField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonDetail" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isReservationScrapingActive" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonUserAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonUser" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "email" } },
					{ kind: "Field", name: { kind: "Name", value: "role" } },
					{ kind: "Field", name: { kind: "Name", value: "lastLoginTime" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>
export const SwitchSalonDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "SwitchSalon" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "salonId" },
					},
					type: {
						kind: "NonNullType",
						type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "switchSalon" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "salonId" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "salonId" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SwitchSalonMutation, SwitchSalonMutationVariables>
export const LoginDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "Login" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "salonId" },
					},
					type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "login" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "salonId" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "salonId" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonAllField" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonName" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salonUser" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonUserAllField" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonUserAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonUser" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "email" } },
					{ kind: "Field", name: { kind: "Name", value: "role" } },
					{ kind: "Field", name: { kind: "Name", value: "lastLoginTime" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>
export const GetClaimRuleDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetClaimRule" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "claimRule" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "text" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetClaimRuleQuery, GetClaimRuleQueryVariables>
export const UpsertClaimRuleDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpsertClaimRule" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpsertClaimRuleInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "upsertClaimRule" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "text" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpsertClaimRuleMutation,
	UpsertClaimRuleMutationVariables
>
export const GetCouponMastersDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCouponMasters" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CouponMastersParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMasters" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterForList" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "targetName" } },
					{ kind: "Field", name: { kind: "Name", value: "discountAmount" } },
					{ kind: "Field", name: { kind: "Name", value: "discountPercent" } },
					{ kind: "Field", name: { kind: "Name", value: "expireDurationDay" } },
					{ kind: "Field", name: { kind: "Name", value: "minAmount" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelsAttachedToCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "relationSummary" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "invoiceCount" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "issuedCount" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "usedCount" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCouponMastersQuery,
	GetCouponMastersQueryVariables
>
export const ActivateCouponMasterDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ActivateCouponMaster" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ActivateCouponMasterInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "activateCouponMaster" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ActivateCouponMasterMutation,
	ActivateCouponMasterMutationVariables
>
export const DeactivateCouponMasterV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "DeactivateCouponMasterV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "DeactivateCouponMasterInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "deactivateCouponMasterV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonAllField" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	DeactivateCouponMasterV2Mutation,
	DeactivateCouponMasterV2MutationVariables
>
export const UpdateDefaultCouponMasterSettingDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateDefaultCouponMasterSetting" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateDefaultCouponMasterSettingInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateDefaultCouponMasterSetting" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "salonAllField" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateDefaultCouponMasterSettingMutation,
	UpdateDefaultCouponMasterSettingMutationVariables
>
export const CreateCouponMasterDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateCouponMaster" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CouponMasterInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createCouponMaster" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonAllField" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useUserPermission" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "UserPermission" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "canUpdateSalon" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpsertClaimRule" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canCreateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canUpdateSalonUserRole" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canSwitchSalonOwner" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isSouhlAdmin" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canInviteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeleteSalonUser" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canActivateCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "canDeactivateCouponMaster" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "canUpdateDefaultCouponMasterSetting",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "useFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isEncouragingRereservationEnabled" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "forceEmptyWhenCannotReserveCanceledReservationMenuSet",
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "address" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "canEnqueueSyncCancels" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enableDefaultCouponMasterForNoConfirmationCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "selectableCancelTypes" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableCancelTypesWithoutUnspecifiedOnes",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "defaultSelectedCancelTypeForCreatingCancel",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "lapsedAfterCancelMinDays" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "defaultCouponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "userPermission" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useUserPermission" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "useFeatureFlag" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateCouponMasterMutation,
	CreateCouponMasterMutationVariables
>
export const BundleClaimDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "BundleClaim" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "BundleClaimInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "bundleClaim" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "failedCancelNames" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<BundleClaimMutation, BundleClaimMutationVariables>
export const GetInvoicePriceDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetInvoicePrice" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "InvoicePriceParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "invoicePrice" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "invoicePrice" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetInvoicePriceQuery,
	GetInvoicePriceQueryVariables
>
export const GetClaimedCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetClaimedCancels" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "claimedCancels" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForList" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetClaimedCancelsQuery,
	GetClaimedCancelsQueryVariables
>
export const GetCouponMastersToSelectDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCouponMastersToSelect" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CouponMastersParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMasters" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterToSelect" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterToSelect" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCouponMastersToSelectQuery,
	GetCouponMastersToSelectQueryVariables
>
export const GetNotClaimedCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetNotClaimedCancels" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "notClaimedCancels" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForList" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetNotClaimedCancelsQuery,
	GetNotClaimedCancelsQueryVariables
>
export const GetPaidCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetPaidCancels" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "paidCancels" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForList" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetPaidCancelsQuery, GetPaidCancelsQueryVariables>
export const GetNotSubjectCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetNotSubjectCancels" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "notSubjectCancels" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForList" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetNotSubjectCancelsQuery,
	GetNotSubjectCancelsQueryVariables
>
export const GetEncourageRereservationMessageNotSentCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "GetEncourageRereservationMessageNotSentCancels",
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "encourageRereservationMessageNotSentCancels",
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForRereservation" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForRereservation" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "messageKind" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationStatus" },
					},
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "rereservedTime" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionAppliedTime" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservation" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteReserveId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "price" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "discountPrice" },
								},
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{ kind: "Field", name: { kind: "Name", value: "staffName" } },
								{ kind: "Field", name: { kind: "Name", value: "menuNames" } },
								{ kind: "Field", name: { kind: "Name", value: "couponNames" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetEncourageRereservationMessageNotSentCancelsQuery,
	GetEncourageRereservationMessageNotSentCancelsQueryVariables
>
export const GetEncourageRereservationMessageSentCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "GetEncourageRereservationMessageSentCancels",
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "encourageRereservationMessageSentCancels",
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForRereservation" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForRereservation" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "messageKind" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationStatus" },
					},
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "rereservedTime" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionAppliedTime" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservation" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteReserveId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "price" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "discountPrice" },
								},
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{ kind: "Field", name: { kind: "Name", value: "staffName" } },
								{ kind: "Field", name: { kind: "Name", value: "menuNames" } },
								{ kind: "Field", name: { kind: "Name", value: "couponNames" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetEncourageRereservationMessageSentCancelsQuery,
	GetEncourageRereservationMessageSentCancelsQueryVariables
>
export const GetRereservedCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetRereservedCancels" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservedCancels" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancels" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "cancelForRereservation" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForRereservation" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "messageKind" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationStatus" },
					},
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "rereservedTime" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionAppliedTime" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservation" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteReserveId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "price" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "discountPrice" },
								},
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{ kind: "Field", name: { kind: "Name", value: "staffName" } },
								{ kind: "Field", name: { kind: "Name", value: "menuNames" } },
								{ kind: "Field", name: { kind: "Name", value: "couponNames" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetRereservedCancelsQuery,
	GetRereservedCancelsQueryVariables
>
export const GetLapsedAfterCancelHighlightEnabledDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetLapsedAfterCancelHighlightEnabled" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "me" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "isLapsedAfterCancelHighlightEnabled",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetLapsedAfterCancelHighlightEnabledQuery,
	GetLapsedAfterCancelHighlightEnabledQueryVariables
>
export const UpdateCancelDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateCancel" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateCancelInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCancel" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "cancelForList" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCancelMutation,
	UpdateCancelMutationVariables
>
export const UpdateCancelForRereservationDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateCancelForRereservation" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateCancelForRereservationInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCancelForRereservation" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "cancelForList" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "couponMasterName" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CouponMaster" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "cancelForList" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Cancel" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "idv2" } },
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{ kind: "Field", name: { kind: "Name", value: "paymentStatus" } },
					{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isVisitCountInvalid" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reserveRoute" } },
					{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
					{ kind: "Field", name: { kind: "Name", value: "invoicePrice" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "staffName" } },
					{ kind: "Field", name: { kind: "Name", value: "paidTime" } },
					{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
					{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
					{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelCouponMasterSpecifiedBy" },
					},
					{ kind: "Field", name: { kind: "Name", value: "isCreatedByUi" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldUseDefaultCouponMaster" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "hasLapsedAfterCancel" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMaster" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "couponMasterName" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCancelForRereservationMutation,
	UpdateCancelForRereservationMutationVariables
>
export const SendInvoiceDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "SendInvoice" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SendInvoiceInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "sendInvoice" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "idv2" } },
								{ kind: "Field", name: { kind: "Name", value: "paymentId" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SendInvoiceMutation, SendInvoiceMutationVariables>
export const ScheduleEncourageRereservationDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ScheduleEncourageRereservation" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ScheduleEncourageRereservationInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "scheduleEncourageRereservation" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancel" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "idv2" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ScheduleEncourageRereservationMutation,
	ScheduleEncourageRereservationMutationVariables
>
export const AbortClaimDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "AbortClaim" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "AbortClaimInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "abortClaim" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "idv2" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<AbortClaimMutation, AbortClaimMutationVariables>
export const BulkUpdateCancelPaymentStatusDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "BulkUpdateCancelPaymentStatus" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "BulkUpdateCancelPaymentStatusInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "bulkUpdateCancelPaymentStatus" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "salonId" } },
								{ kind: "Field", name: { kind: "Name", value: "reserveId" } },
								{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "paymentStatus" },
								},
								{ kind: "Field", name: { kind: "Name", value: "visitCounts" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "reserveRoute" },
								},
								{ kind: "Field", name: { kind: "Name", value: "originPrice" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "invoicePrice" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
								{ kind: "Field", name: { kind: "Name", value: "dateVisit" } },
								{ kind: "Field", name: { kind: "Name", value: "dateCancel" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "isCouponEnabled" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	BulkUpdateCancelPaymentStatusMutation,
	BulkUpdateCancelPaymentStatusMutationVariables
>
export const LoadCancelsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "LoadCancels" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "LoadCancelsInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "loadCancels" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ok" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<LoadCancelsMutation, LoadCancelsMutationVariables>
export const GetNotClaimedCancelsNotificationLogDisplayedCancelIdsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "GetNotClaimedCancelsNotificationLogDisplayedCancelIds",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value:
									"NotClaimedCancelsNotificationLogDisplayedCancelIdsParam",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "notClaimedCancelsNotificationLogDisplayedCancelIds",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "displayedCancelIds" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetNotClaimedCancelsNotificationLogDisplayedCancelIdsQuery,
	GetNotClaimedCancelsNotificationLogDisplayedCancelIdsQueryVariables
>
export const GetCouponMastersToCreateCancelDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCouponMastersToCreateCancel" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CouponMastersParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "couponMasters" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCouponMastersToCreateCancelQuery,
	GetCouponMastersToCreateCancelQueryVariables
>
export const CreateCancelDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateCancel" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateCancelInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createCancel" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "cancel" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "idv2" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateCancelMutation,
	CreateCancelMutationVariables
>
export const UpdateSalonDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateSalon" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateSalonInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalon" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "displayName" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "address" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<UpdateSalonMutation, UpdateSalonMutationVariables>
export const GetSalonUsersDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSalonUsers" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "salonUsers" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "salonUserAllField" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonUserAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonUser" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "email" } },
					{ kind: "Field", name: { kind: "Name", value: "role" } },
					{ kind: "Field", name: { kind: "Name", value: "lastLoginTime" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GetSalonUsersQuery, GetSalonUsersQueryVariables>
export const UpdateSalonUserRoleDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateSalonUserRole" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateSalonUserRoleInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalonUserRole" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salonUser" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "salonUserAllField" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "salonUserAllField" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "SalonUser" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "email" } },
					{ kind: "Field", name: { kind: "Name", value: "role" } },
					{ kind: "Field", name: { kind: "Name", value: "lastLoginTime" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonUserRoleMutation,
	UpdateSalonUserRoleMutationVariables
>
export const SwitchSalonOwnerDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "SwitchSalonOwner" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SwitchSalonOwnerInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "switchSalonOwner" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ok" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	SwitchSalonOwnerMutation,
	SwitchSalonOwnerMutationVariables
>
export const DeleteSalonUserDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "DeleteSalonUser" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "DeleteSalonUserInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "deleteSalonUser" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ok" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	DeleteSalonUserMutation,
	DeleteSalonUserMutationVariables
>
export const InviteSalonUserDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "InviteSalonUser" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "InviteSalonUserInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "inviteSalonUser" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ok" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	InviteSalonUserMutation,
	InviteSalonUserMutationVariables
>
export const MakeSelfSalonOwnerDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "MakeSelfSalonOwner" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "makeSelfSalonOwner" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: { kind: "ObjectValue", fields: [] },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ok" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	MakeSelfSalonOwnerMutation,
	MakeSelfSalonOwnerMutationVariables
>
export const GetCancelTypeInfosDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCancelTypeInfos" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelTypeInfo" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
								{ kind: "Field", name: { kind: "Name", value: "text" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCancelTypeInfosQuery,
	GetCancelTypeInfosQueryVariables
>
